// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__77TZy","rows":"Monitor_rows__fjpBm","boxes":"Monitor_boxes__A99f-","attitude":"Monitor_attitude__-Za3S"};